import { render } from "./companyComplaints.vue?vue&type=template&id=7bd24f00"
import script from "./companyComplaints.vue?vue&type=script&lang=js"
export * from "./companyComplaints.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__